import {z} from "zod";

export const reportOneFormSchema = z.object({
	dateFrom: z.string(),
	dateTo: z.string(),
	managerIds: z.array(z.string())
});

export type ReportOneFormType = z.infer<typeof reportOneFormSchema>;

export const reportOneSchema = z.object({
	dateRangeValue: z.object({
		from: z.string().optional(),
		to: z.string().optional()
	}),
	managerIds: z.array(z.string()).optional()
});

export type ReportOneType = z.infer<typeof reportOneSchema>;
